import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "proofreading-panel" }
const _hoisted_2 = { class: "state-breadcrumb" }
const _hoisted_3 = { class: "state-label" }
const _hoisted_4 = {
  key: 0,
  class: "actions"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "info-row" }
const _hoisted_7 = { class: "info-label" }
const _hoisted_8 = {
  key: 0,
  class: "info-row"
}
const _hoisted_9 = { class: "info-label" }
const _hoisted_10 = { class: "info-row" }
const _hoisted_11 = { class: "info-label" }
const _hoisted_12 = { class: "password" }
const _hoisted_13 = { class: "actions" }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { class: "info-row" }
const _hoisted_16 = { class: "info-label" }
const _hoisted_17 = { class: "info-row" }
const _hoisted_18 = { class: "info-label" }
const _hoisted_19 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('proofreading.state')) + ":", 1),
      _createElementVNode("span", {
        class: _normalizeClass({ bold: _ctx.isActive })
      }, _toDisplayString(_ctx.$t('proofreading.stateInTranslation')), 3),
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "separator" }, " > ", -1)),
      _createElementVNode("span", {
        class: _normalizeClass({ bold: _ctx.isInProofreading })
      }, _toDisplayString(_ctx.$t('proofreading.stateInProofreading')), 3),
      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "separator" }, " > ", -1)),
      _createElementVNode("span", {
        class: _normalizeClass({ bold: _ctx.isProofreadingComplete })
      }, _toDisplayString(_ctx.$t('proofreading.stateProofreadingComplete')), 3)
    ]),
    (_ctx.isActive)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            loading: _ctx.loading,
            onClick: _ctx.exportForReview
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('proofreading.exportForProofreading')), 1)
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ]))
      : (_ctx.isInProofreading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('proofreading.exportedAt')) + ":", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(_ctx.document.proofreadingExportedAt)), 1)
            ]),
            (_ctx.document.proofreadingExportVersion)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('proofreading.exportVersion')) + ":", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.formatVersion(_ctx.document.proofreadingExportVersion)), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('proofreading.documentPassword')) + ":", 1),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.document.proofreadingPassword), 1),
              _createVNode(_component_el_tooltip, {
                content: _ctx.$t('proofreading.copyPassword')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: "material-symbols-outlined copy-button",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyPassword && _ctx.copyPassword(...args)))
                  }, " content_copy ")
                ]),
                _: 1
              }, 8, ["content"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("input", {
                ref: "fileInput",
                type: "file",
                accept: ".docx",
                style: {"display":"none"},
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args)))
              }, null, 544),
              _createVNode(_component_el_button, {
                type: "primary",
                plain: "",
                loading: _ctx.loading,
                onClick: _ctx.triggerFileInput
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('proofreading.uploadProofreadDocument')), 1)
                ]),
                _: 1
              }, 8, ["loading", "onClick"]),
              _createVNode(_component_el_button, {
                type: "warning",
                loading: _ctx.loading,
                onClick: _ctx.cancelProofreading
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('proofreading.cancelProofreading')), 1)
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ]))
        : (_ctx.isProofreadingComplete)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('proofreading.exportedAt')) + ":", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(_ctx.document.proofreadingExportedAt)), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('proofreading.completedAt')) + ":", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(_ctx.document.proofreadingCompletedAt)), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_el_button, {
                  type: "warning",
                  loading: _ctx.loading,
                  onClick: _ctx.resetToInTranslation
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('proofreading.resetToInTranslation')), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
  ]))
}